import type { ReactNode } from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { ReviewThread } from './ReviewThread';
import type { ReviewThreadEntry } from '../collabTypes';

/**
 * The conversation about a working copy — the same slide-over on the reviewer's screen and the
 * author's editor.
 *
 * It was the same markup in both routes, and the copies drifted: the author's composer never
 * named the change it was about, so you typed into a box that did not say what you had clicked.
 * One shell instead. The composer stays a prop because who is writing decides it — a reviewer
 * comments, an author replies, and the reviewer's screen serves both.
 *
 * Why a slide-over: it never steals width from the document. Why a column: the drawer itself
 * must not scroll, or the composer walks off the bottom as the thread grows (it did, and a long
 * thread made commenting impossible). ReviewThread scrolls its own list and keeps the composer
 * docked.
 */
export function DiscussionSheet({
  open,
  onOpenChange,
  entries,
  currentEmail,
  composer,
}: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  entries: ReviewThreadEntry[];
  currentEmail: string | null;
  composer: ReactNode;
}) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="flex w-full flex-col gap-0 overflow-hidden p-4 sm:max-w-md">
        <SheetHeader className="sr-only">
          <SheetTitle>Discussion</SheetTitle>
        </SheetHeader>
        <ReviewThread entries={entries} composer={composer} fill currentEmail={currentEmail} />
      </SheetContent>
    </Sheet>
  );
}
